import { render } from "./propertiesButton.vue?vue&type=template&id=01285572"
import script from "./propertiesButton.vue?vue&type=script&lang=js"
export * from "./propertiesButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__